export enum UserPanelTab {
  Profile = 'profile',
  Home = 'home',
  History = 'history',
}
